import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { LocalstorageService } from '../storage/localstorage.service';
import { ApiService } from '../api.service';
import { Router } from '@angular/router';

@Injectable({
  providedIn: 'root'
})
export class StatusCargaService {

  constructor(
    public localStorage:LocalstorageService,
    private API: ApiService,
    private router: Router
  ) { }

    private dataSubject = new BehaviorSubject<any>({
      "status":false,
      "ent_read":0,
      "ent_proc":0,
      "ent_erro":0,
      "ent_qtdc":0
    })

    private homeSubject = new BehaviorSubject<any>({
      "status":false,
      "ent_read":0,
      "ent_proc":0,
      "ent_erro":0,
      "ent_succ":0,
      "ent_qtdc":0,
      "sai_read":0,
      "sai_proc":0,
      "sai_erro":0,
      "sai_qtdc":0
    })

    data$ = this.dataSubject.asObservable();
    dataHome$ = this.homeSubject.asObservable();

  
  setData(){
    const _self = this;
      _self.API.getFromApi("Functions","recarregaStatusDiretorio",{},(Retorno:any) =>{
        
        if(Retorno.status){
          Retorno.data.ent_qtdc = Retorno.data.ent_read + Retorno.data.ent_proc + Retorno.data.ent_erro;
          Retorno.data.sai_qtdc = Retorno.data.sai_read + Retorno.data.sai_proc + Retorno.data.sai_erro;
          
          _self.dataSubject.next(Retorno.data)
           if(this.router.url == '/home'){
            _self.homeSubject.next(Retorno.data)
           }
          if(Retorno.data.status){
            setTimeout(() => {
              _self.setData()
            }, 10000);
          }else if(this.router.url == '/home'){
            setTimeout(() => {
              _self.setData()
            }, 10000);
          }
        }
      },false, "");
  }

  loadStatus(){
    const _self = this;

    
    _self.setData()

  }

}
